import { HBBuySellRecordVO, HbKLineBaseVO } from "@/types/general";
import { request } from "../request";

export function fetchGetSymbolsListAsync() {
    return request<any>({
        url: '/HuoBi/GetSymbolsList',
        method: 'get',
    });
}
/**
 * 获取历史Kline
 * @returns 
 */
export function fetchGetHistoryKlineAsync(
    symbol: string,
    period: "1min" | "5min" | "15min" | "30min" | "60min" | "4hour" | "1day" | "1mon" | "1week" | "1year",
    size: number=2000) {
    if(!size)
        size = 2000;
    return request<HbKLineBaseVO[]>({
        url: '/HuoBi/GetHistoryKline',
        method: 'get',
        params: {
            symbol,
            period,
            size
        }
    });
}

/**
 * 获取市场最新交易记录
 * @param symbol 
 * @param size 
 */
export function fetchGetMarketTradeListAsync(symbol: string, size: number) {
    return request<HBBuySellRecordVO[]>({
        url: '/HuoBi/GetMarketTradeList',
        method: 'get',
        params: {
            symbol,
            size
        }
    });
}

/**
 * 获取某产品的最新价格
 * @param productCode 产品编号
 */
export function fetchGetProductCurrentPriceAsync(productCode: string) {
    return request<{
        amount: number
    }>({
        url: '/HuoBi/GetProductCurrentPrice',
        method: 'get',
        params: {
            productCode
        }
    });
}